import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../component/sidebar";
import { Grid, Typography } from "@mui/material";
import Header from "../../component/header";
import BasicTable from "../tables/BasicTable";
import {
  useGetDoctorQuery,
  useUpdateDoctorMutation,
  useDeleteDoctorMutation,
  useAddDoctorMutation,
} from "../../../../services/doctorSlice";
import DoctorAddButton from "./doctorAddButton";
import { Box } from "@mui/system";

const DashboardDoctors = () => {
  return (
    <Grid container className="dashboard-full-background">
      <Grid item xs={2} spacing={4}>
        <Sidebar />
      </Grid>
      <Grid item xs={10}>
        <Header />
        <DashboardDoctorsPages />
      </Grid>
    </Grid>
  );
};

const DashboardDoctorsPages = () => {
  const { data, isLoading, isSuccess, isError, error } =
    useGetDoctorQuery("getDoctors");

  const [deleteDoctor] = useDeleteDoctorMutation();

  const deleteConfirm = (e, id) => {
    e.preventDefault();
    deleteDoctor({ id });
  };

  let headers = [];
  let tableData = [];
  let content;
  if (isLoading) {
    content = <p>"Loading..."</p>;
  } else if (isSuccess) {
    headers = ["Image", "Name", "Speciality", "Description"];
    tableData = [];
    data.ids.forEach((key) => {
      tableData.push({
        Image: data.entities[key].image,
        id: data.entities[key].id,
        Speciality: data.entities[key].speciality,
        Description: data.entities[key].description
      });
    });
  }
  return (
    <>
      <Box className="table-design-background">
        <Grid container>
          <Grid item xs={6}>
            <Typography className="dashboard-home-page-text">
              Doctors Lists
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Link to="/dashboard/new/doctors" style={{textDecoration:'none'}}>
              <DoctorAddButton />
            </Link>
          </Grid>
        </Grid>
        <Box style={{ padding: "1.5rem" }}>
          <BasicTable
            headers={headers}
            data={tableData}
            isDelete={true}
            deleteColor={"#f50057"}
            isEdit={true}
            editColor={"#3f51b5"}
            addColor={""}
            tableName={"doctors"}
            deleteConfirm={deleteConfirm}
            activeSign={["Active"]}
          />
        </Box>
      </Box>
    </>
  );
};
export default DashboardDoctors;
